exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".supplier-checkbox{color:#8492a6;font-size:12px;padding-left:8px}.supplier-select-popover.el-select-dropdown.is-multiple .el-select-dropdown__item.is-disabled{color:#bfc7d9;background-color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-827b1898","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/views/operation/addPositionDialog.vue
// module id = 947
// module chunks = 23